/* Belasil: Shopify is the consent source of truth. */
(function () {
  var started = false, previous = null;
  function clearDeclinedCookies(cp) {
    var choice = cp.currentVisitorConsent();
    var names = document.cookie.split(';').map(function (part) { return part.split('=')[0].trim(); });
    names.forEach(function (name) {
      var analyticsCookie = /^(_ga($|_)|_gid$|_gat($|_)|_hj|_clck$|_clsk$)/.test(name);
      var marketingCookie = /^(_gcl_|_fbp$|_fbc$|_ttp$|_tt_enable_cookie$|ttcsid($|_))/.test(name);
      if (!((choice.analytics === 'no' && analyticsCookie) || (choice.marketing === 'no' && marketingCookie))) return;
      ['', location.hostname, '.' + location.hostname, '.belasil.ro'].forEach(function (domain) {
        document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + (domain ? '; Domain=' + domain : '');
      });
    });
  }
  function sync() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp) return false;
    clearDeclinedCookies(cp);
    var analytics = cp.analyticsProcessingAllowed(), marketing = cp.marketingAllowed();
    var state = {analytics_storage: analytics ? 'granted' : 'denied', ad_storage: marketing ? 'granted' : 'denied', ad_user_data: marketing ? 'granted' : 'denied', ad_personalization: marketing ? 'granted' : 'denied'};
    window.gtag('consent', 'update', state);
    if (window.clarity) window.clarity('consentv2', {analytics_Storage: state.analytics_storage, ad_Storage: state.ad_storage});
    if (previous && ((previous.analytics && !analytics) || (previous.marketing && !marketing))) {
      // A new page also stops integrations without a runtime withdrawal API.
      window.location.reload();
      return true;
    }
    previous = {analytics: analytics, marketing: marketing};
    if (analytics && !started && document.documentElement.dataset.belasilSessionAnalytics === 'true') {
      started = true;
      window.hj = window.hj || function () {(window.hj.q = window.hj.q || []).push(arguments);};
      window._hjSettings = {hjid:5272605,hjsv:6};
      var hotjar = document.createElement('script'); hotjar.async = true;
      hotjar.src = 'https://static.hotjar.com/c/hotjar-5272605.js?sv=6'; document.head.appendChild(hotjar);
      window.clarity = window.clarity || function () {(window.clarity.q = window.clarity.q || []).push(arguments);};
      window.clarity('consentv2', {analytics_Storage: state.analytics_storage, ad_Storage: state.ad_storage});
      var clarity = document.createElement('script'); clarity.async = true;
      clarity.src = 'https://www.clarity.ms/tag/xf4y484aup'; document.head.appendChild(clarity);
    }
    return true;
  }
  document.addEventListener('visitorConsentCollected', sync);
  var attempts = 0, featureRequested = false;
  function ready() {
    if (sync()) return;
    if (!featureRequested && window.Shopify && Shopify.loadFeatures) {
      featureRequested = true;
      Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) sync(); });
    }
    if (++attempts < 200) window.setTimeout(ready, 100);
  }
  ready();
})();
